import { render } from "./MarginsByCustomer.vue?vue&type=template&id=65f9e604"
import script from "./MarginsByCustomer.vue?vue&type=script&lang=ts"
export * from "./MarginsByCustomer.vue?vue&type=script&lang=ts"
script.render = render

export default script